"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "wf-component wf-component--select-card" };
const _hoisted_2 = {
    key: 0,
    class: "nofloat wf-component-title"
};
const _hoisted_3 = ["value"];
const _hoisted_4 = ["value", "disabled"];
const _hoisted_5 = {
    key: 1,
    class: "card-warning"
};
const _hoisted_6 = {
    key: 2,
    class: "nofloat"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Card = (0, vue_1.resolveComponent)("Card");
    const _component_warnings_component = (0, vue_1.resolveComponent)("warnings-component");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.showtitle === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getOrderedCards(), (card) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                key: card.name,
                class: (0, vue_1.normalizeClass)(_ctx.getCardBoxClass(card))
            }, [
                (!card.isDisabled)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                        (_ctx.selectOnlyOneCard)
                            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("input", {
                                key: 0,
                                type: "radio",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.cards) = $event)),
                                value: card
                            }, null, 8, _hoisted_3)), [
                                [vue_1.vModelRadio, _ctx.cards]
                            ])
                            : (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("input", {
                                key: 1,
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.cards) = $event)),
                                value: card,
                                disabled: _ctx.playerinput.max !== undefined && Array.isArray(_ctx.cards) && _ctx.cards.length >= _ctx.playerinput.max && _ctx.cards.includes(card) === false
                            }, null, 8, _hoisted_4)), [
                                [vue_1.vModelCheckbox, _ctx.cards]
                            ])
                    ], 64))
                    : (0, vue_1.createCommentVNode)("", true),
                (0, vue_1.createVNode)(_component_Card, {
                    card: card,
                    actionUsed: _ctx.isCardActivated(card),
                    robotCard: _ctx.robotCard(card)
                }, {
                    default: (0, vue_1.withCtx)(() => [
                        (_ctx.playerinput.showOwner)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: 0,
                                class: (0, vue_1.normalizeClass)('card-owner-label player_translucent_bg_color_' + _ctx.getOwner(card).color)
                            }, (0, vue_1.toDisplayString)(_ctx.getOwner(card).name), 3))
                            : (0, vue_1.createCommentVNode)("", true)
                    ]),
                    _: 2
                }, 1032, ["card", "actionUsed", "robotCard"])
            ], 2));
        }), 128)),
        (_ctx.hasCardWarning())
            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.warning), 1)
            ])), [
                [_directive_i18n]
            ])
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createVNode)(_component_warnings_component, { warnings: _ctx.warnings }, null, 8, ["warnings"]),
        (_ctx.showsave === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_6, [
                (0, vue_1.createVNode)(_component_AppButton, {
                    disabled: _ctx.isOptionalToManyCards && _ctx.cardsSelected() === 0,
                    type: "submit",
                    onClick: _ctx.saveData,
                    title: _ctx.buttonLabel()
                }, null, 8, ["disabled", "onClick", "title"]),
                (_ctx.isOptionalToManyCards)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_AppButton, {
                        key: 0,
                        disabled: _ctx.isOptionalToManyCards && _ctx.cardsSelected() > 0,
                        onClick: _ctx.saveData,
                        type: "submit",
                        title: _ctx.$t('Skip this action')
                    }, null, 8, ["disabled", "onClick", "title"]))
                    : (0, vue_1.createCommentVNode)("", true)
            ]))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
